module.exports = __webpack_public_path__ + "static/media/roboto-v27-latin-regular.aa23b7b4.woff2";